// extracted by mini-css-extract-plugin
export default {"FCoverImageEditor":"FCoverImageEditor___bdC5Y","hover_visible":"hover_visible___bKgvZ","hover_hidden":"hover_hidden___PSd2K","coverEdit":"coverEdit___ZkgLE"};